import { SupportedConnectors } from '../config/constants';
import { injected, walletConnect, walletlink } from './connectors';

const walletConnections: Partial<Record<SupportedConnectors, any>> = {
    [SupportedConnectors.METAMASK]: injected,
    [SupportedConnectors.COINBASE]: walletlink,
    [SupportedConnectors.WALLET_CONNECT]: walletConnect,
};

export const ClosableWallet = [
    SupportedConnectors.METAMASK,
    SupportedConnectors.COINBASE,
    SupportedConnectors.WALLET_CONNECT,
];

export default walletConnections;
